import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Row,
  Typography,
  notification,
} from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { translation } from "../../i18n/translationConstant";
import { AddIdentifier } from "../../Models/Request/Identifier/AddIdentifier";
import { GetIdentifierResponse } from "../../Models/Response/Identifier/Identifier";
import {
  addIdentifier,
  addIdentifierVerification,
  getIdentifiers,
} from "../../Services/IdentifierService/Identifier";
import { IdentifierCategory } from "../../Utils/Constants/identifierType";
import "./index.css";
import UserIdentification from "./UserIdentification";
import { EntityIdentifier } from "../../Models/Request/Identifier/EntityIdentifier";

interface IIdentifiersProps {
  onRadioSelect: (e: any) => void;
  onSelectIdentifier: (identifier: AddIdentifier[]) => void;
  modalVisibility: boolean;
  onCloseModal: () => void;
  fipEntityIdentifiers: EntityIdentifier[];
}

const Identifiers: React.FC<IIdentifiersProps> = (
  {
    onRadioSelect,
    onSelectIdentifier,
    modalVisibility,
    onCloseModal,
    fipEntityIdentifiers,
  },
  props
) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [identifiers, setIndentifiers] = useState<AddIdentifier[]>([]);
  const [visible, setVisibility] = useState(false);
  const [isAddIdentifierVerification, setVerification] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [selectedIdentifier, setSelectedIdentifier] = useState<AddIdentifier[]>([]);
  const [selectedOpt, setSelectedOpt] = useState<{
    [key: string]: string | null;
  }>({});

  const { Text } = Typography;

  useEffect(() => {
    // getIdentifiers()
    //   .then((res) => res.data)
    //   .then((res) => {
    //     // setIndentifiers(res);
    //     const getFilteredIdentifers = getFinalIdentifiersMatchList(
    //       res,
    //       fipEntityIdentifiers
    //     );

    //     // TODO: Loop here
    //     selectFirstIdentifiers(getFilteredIdentifers);

    //     setIndentifiers(getFilteredIdentifers);

    //     // onRadioSelect([res[0]]); // Adds the identifier
    //     // setSelectedIdentifier([res[0]]); // Selects identifiers checkbox
    //   });
    getIdentifiersFiltered()
  }, [onRadioSelect]);

  const getIdentifiersFiltered = () => getIdentifiers()
  .then((res) => res.data)
  .then((res) => {
    // setIndentifiers(res);
    const getFilteredIdentifers = getFinalIdentifiersMatchList(
      res,
      fipEntityIdentifiers
    );

    // TODO: Loop here
    selectFirstIdentifiers(getFilteredIdentifers);

    setIndentifiers(getFilteredIdentifers);

    // onRadioSelect([res[0]]); // Adds the identifier
    // setSelectedIdentifier([res[0]]); // Selects identifiers checkbox
  });

  const onCancel = () => {
    setVisibility(false);
    setVerification(false);
  };

  function getFinalIdentifiersMatchList(
    allIdentifiers: AddIdentifier[],
    fipEntityIdentifiers: EntityIdentifier[]
  ) {
    // Remove elements from allIdentifiers that do not exist in fipEntityIdentifier
    allIdentifiers = allIdentifiers.filter((identifier) =>
      fipEntityIdentifiers.some(
        (fipIdentifier) =>
          fipIdentifier.category?.toUpperCase() ===
            identifier.categoryType?.toUpperCase() &&
          fipIdentifier.type?.toUpperCase() === identifier.type?.toUpperCase()
      )
    );

    // Add identifier types from fipEntityIdentifier that are not present in allIdentifiers
    fipEntityIdentifiers.forEach((fipIdentifier) => {
      if (
        !allIdentifiers.some(
          (identifier) =>
            fipIdentifier.category?.toUpperCase() ===
              identifier.categoryType?.toUpperCase() &&
            fipIdentifier.type?.toUpperCase() === identifier.type?.toUpperCase()
        )
      ) {
        allIdentifiers.push({
          categoryType: fipIdentifier.category?.toUpperCase(),
          type: fipIdentifier.type?.toUpperCase(),
          value: "",
        });
      }
    });

    return allIdentifiers;
    // setIndentifiers(allIdentifiers);
  }

  function selectFirstIdentifiers(filteredIdentifiers: AddIdentifier[]) {
    const encounteredTypes: AddIdentifier[] = [];

    filteredIdentifiers.forEach((identifier) => {
      // if(!encounteredTypes.)
      if (
        !encounteredTypes.find(
          (eIdentifier) => identifier.type == eIdentifier.type
        )
      ) {
        encounteredTypes.push(identifier);
      }
    });
    setSelectedIdentifier(encounteredTypes);
    onRadioSelect(encounteredTypes);
  }

  const onIdentifierEntered = (iNumber: any) => {
    addIdentifier(iNumber)
      .then((res) => res.data)
      .then((res) => {
        if (iNumber.categoryType === IdentifierCategory.STRONG) {
          setVerification(true);
          setOTPUniqueId(res.mobile.otpUniqueID);
        } else {
          // getIdentifiers()
          //   .then((res) => res.data)
          //   .then((res) => setIndentifiers(res));
          getIdentifiersFiltered()
          setVisibility(false);
          onCloseModal();
          setVerification(false);
          form.resetFields();
        }
      });
  };

  const onOTPSubmit = (otp: string, identifier: any) => {
    addIdentifierVerification({
      code: otp,
      otpUniqueID,
      identifierValue: identifier.value,
      categoryType: identifier.categoryType,
      type: identifier.type,
    }).then(() => {
      // getIdentifiers()
      //   .then((res) => res.data)
      //   .then((res) => setIndentifiers(res));
      getIdentifiersFiltered()
      setVisibility(false);
      onCloseModal();
      setVerification(false);
      form.resetFields();
    });
  };

  const identifierSelectionChange = (e: CheckboxValueType[]) => {
    const localIdentifier = identifiers.filter(
      (i: any) => e.indexOf(i.value + i.type) !== -1
    );

    const localIdentifier1 = identifiers.filter(
      (i: any) => console.log(e.indexOf(i.value + i.type))
    );


    const localIdentifier2 = identifiers.filter(
      (i: any) => e.indexOf(i.value + i.type)
    );
    console.log("localIdentifier--->", localIdentifier);
    console.log("localIdentifier1--->", localIdentifier1);

    onRadioSelect(localIdentifier);
    setSelectedIdentifier(localIdentifier);
  };

  const handleChackbox = (isChecked:boolean,selectedItem:AddIdentifier,category: any, type: any, value: any) => {
    
    console.log("Selected Value :",selectedItem);
    setSelectedOpt((prev: any) => {
      return { ...prev, [category]: { ...prev[category], [type]: value } };
    });

    setSelectedOpt((prev: any) => {
      return { ...prev, [category]: { ...prev[category], [type]: value } };
    });
   /* if(selectedIdentifier.includes(selectedItem)){
      setSelectedIdentifier(selectedIdentifier.filter(identifier => identifier != selectedItem));
    }else{
      setSelectedIdentifier([...selectedIdentifier,selectedItem]);
    } */
  };

  const callOnRadioSelect = (updateflag : boolean) => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    const checkedItems :AddIdentifier[] = Array.from(checkboxes).map(checkbox => {
      console.log("Count :",checkbox);
      const type = checkbox.getAttribute('name') || '';
      const value = checkbox.getAttribute('value') || '';
      const categoryType = checkbox.getAttribute('id') || '';
      return {type,value,categoryType};
    });

    
    if(updateflag){
      onRadioSelect(checkedItems);
    }
    // Your logic here...
    return ""; // JSX element returned by the function
  };

  const isChacked = (category: any, type: any, value: any, index: number) => {
    if (selectedOpt[category] === undefined && index == 0) {
      setSelectedOpt((prev: any) => {
        return { ...prev, [category]: { ...prev[category], [type]: value } };
      });
    }

    return selectedOpt[category] !== undefined &&
      selectedOpt[category]?.[type] === value
      ? true
      : false;
  };
  const validateSelectedIdentifiers = () => {


    

    if (selectedIdentifier.length !== 0) {

      const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
      const checkedItems :AddIdentifier[] = Array.from(checkboxes).map(checkbox => {
        console.log("Count :",checkbox);
        const type = checkbox.getAttribute('name') || '';
        const value = checkbox.getAttribute('value') || '';
        const categoryType = checkbox.getAttribute('id') || '';
        return {type,value,categoryType};
      });
  
      onRadioSelect(checkedItems);


      const validIdentifiers: AddIdentifier[] = [];
      let matchingEntityIdentifier: AddIdentifier | undefined;

      fipEntityIdentifiers.forEach((fipIdentifiers) => {
        matchingEntityIdentifier = selectedIdentifier.find((identifier) => {
          if (
            fipIdentifiers.category.toUpperCase() ==
              identifier.categoryType.toUpperCase() &&
            fipIdentifiers.type.toUpperCase() == identifier.type.toUpperCase()
          ) {
            validIdentifiers.push(identifier);
            return true;
          } else {
            return false;
          }
        });

        if (!matchingEntityIdentifier) {
          notification.error({
            message: `Identifier Type: ${fipIdentifiers.type} not selected.`,
          });
        }
      });

      if (matchingEntityIdentifier) {
        onSelectIdentifier(checkedItems); // Call the function when valid identifiers are selected
      }
    } else {
      return notification.error({
        message: "Please select a valid identifier.",
      });
    }
  };

  const setModalVisibility = () => {
    setVisibility(true);
  };

  return (
    <div className="identifierRoot">
      <div className="radioSection">
        <Row gutter={16}>
          {identifiers &&
            identifiers
              .filter((res) => res.categoryType === IdentifierCategory.STRONG)
              .map((singleIdentifier: GetIdentifierResponse, index) => (
                <Col span={12}>
                  <Typography.Text className="fontSize18FontWeight500">
                    {/* {t(translation.lblStrongIdentifier)}  */}

                    {singleIdentifier.type}
                  </Typography.Text>
                  <Card key={index} className="identifierCard">
                    <Checkbox
                      onChange={(e) =>
                        handleChackbox(
                          e.target.checked,
                          singleIdentifier,
                          "STRONG",
                          singleIdentifier.type,
                          e.target.value,
                        )
                      }
                      value={singleIdentifier.value}
                      name={singleIdentifier.type}
                      id={singleIdentifier.categoryType}

                      checked={isChacked("STRONG",singleIdentifier.type,singleIdentifier.value,index)}
                      
                    >
                      <Text>{singleIdentifier.value}</Text>
                    </Checkbox>
                  </Card>
                </Col>
              ))}

          {identifiers &&
            identifiers
              .filter((res) => res.categoryType !== IdentifierCategory.STRONG)
              .map((singleIdentifier: GetIdentifierResponse, index) => (
                <Col span={12}>
                  <Typography.Text className="fontSize18FontWeight500">
                    {/* {t(translation.lblWeakIdentifier)} ( */}
                    {singleIdentifier.type}
                  </Typography.Text>
                  <Card key={index} className="accountCard identifierCard">
                    <Checkbox
                      onChange={(e) =>
                        handleChackbox( 
                          e.target.checked,  
                          singleIdentifier,                       
                          "STRONG",
                          singleIdentifier.type,
                          e.target.value
                        )
                      }
                      value={singleIdentifier.value}
                      name={singleIdentifier.type}
                      id={singleIdentifier.categoryType}
                      checked={isChacked("STRONG",singleIdentifier.type,singleIdentifier.value,index)}
                    >
                      <Text>{singleIdentifier.value}</Text>
                    </Checkbox>
                  </Card>
                </Col>
              ))}
        </Row>
      </div>
      <div className="actionButtonGroup">
        {/* <Button
          className="commonButtonBackground addIdentifier secondaryButton secondaryCustom"
          onClick={setModalVisibility}
        >
          {t(translation.lblAddIdentifier)}
        </Button> */}
        {/* <div>{' '}</div> */}
        <Button
          // disabled={selectedIdentifier.length ? false : true}
          className="commonButtonBackground primaryButton linkAccountNoAccounts primaryCustom secondaryButtonWidth"
          onClick={validateSelectedIdentifiers}
        >
          {t(translation.lblDiscoverAccounts)}
        </Button>
        
      </div>
      {callOnRadioSelect(false)}
      <UserIdentification
        form={form}
        visible={modalVisibility}
        handleCancel={onCloseModal}
        identifierEntered={onIdentifierEntered}
        onOTPSubmit={onOTPSubmit}
        isAddIdentifierVerification={isAddIdentifierVerification}
        label={t(translation.lblAddIdentifier)}
        multipleIdentifiers={true}
        isForgotPassword={false}
        entityIdentifiers={fipEntityIdentifiers}
      />

    </div>
  );
};
export default Identifiers;
